import BaseModel, { executePaste_Parameters } from "./BaseModel";

import BaseObject from "./BaseObject";
import AreaTreeViewModel from "../modelTreeViews/AreaTreeViewModel";

import { copyAllProperties } from "./utils";

import Logger from "../Logger";

const logger = new Logger();

//////////////////////////////////////////////////
import ObjectFactory from "./ObjectFactory";
import Line from "./Line";
import { channelTypeInfo } from "./ChannelType";
import BaseModelMap from "./BaseModelMap";
import { itx } from "../translationItx/itx";

ObjectFactory.registerClass("Area", (data?: any, parent?: BaseModel) => {
  // no itx
  return new Area({});
});
//////////////////////////////////////////////////
export default class Area extends BaseModel {
  public get className(): string {
    return "Area"; // no itx
  }

  get isPersistent(): boolean {
    return false;
  }

  areaNumber: number = 0;
  lines: BaseModelMap<Line> = new BaseModelMap<Line>(Line, this, "lin", false); // no itx

  override getName(): string | undefined {
    return globalThis.state?.settings?.getTopologyAreaName(this.areaNumber);
  }

  override setName(newValue: string): void {
    if (globalThis.state?.settings) {
      state.settings.setTopologyAreaName(this.areaNumber, newValue);
    }
    this._name = newValue;
  }

  getLines(): Array<BaseModel> | undefined {
    this.updateLines();
    return this.lines.sortIntBy("tag");
  }

  getPersistentProperties(): string[] {
    return ["itemNumber", ...super.getPersistentProperties()]; // no itx
  }

  emptyTagIsForbidden(): boolean {
    return state.floors.size > 1;
  }

  canBeEditedInteractive(): boolean {
    return false;
  }

  constructor(data?: any, parent?: BaseObject) {
    super(data, parent);
    copyAllProperties(data, this);
    const storedName = globalThis.state?.settings?.getTopologyAreaName(this.areaNumber);
    if (storedName !== undefined) this._name = storedName;
    this.treeViewModel = new AreaTreeViewModel(this);
  }

  //////////////////////////////////////////////////////
  ///////////// for copy

  getExtendedCopyCollection(startItem: BaseModel): Array<BaseModel> {
    const res = new Array<BaseModel>();
    return res;
  }
  //////////////////////////////////////////////////////
  ///////////// for paste

  mapAfterCopy() {
    if (!this.mapAfterCopyDone) {
      super.mapAfterCopy();
    }
  }
  async pasteItem(params: { item: BaseModel; allItems: Array<BaseModel> }): Promise<Array<BaseModel>> {
    return [];
  }

  async executePaste(params: executePaste_Parameters): Promise<Array<BaseModel>> {
    const { parent, isCopyRootObj } = params;
    var undoObjects: Array<BaseModel> = [this];

    return undoObjects;
  }

  setTag(newValue: string) {
    const areaNumber = parseInt(newValue);
    if (areaNumber >= 0 && areaNumber <= 15) {
      const oldAreaNumber = this.areaNumber;
      if (oldAreaNumber !== areaNumber) {
        state.settings.moveTopologyAreaLineNames(oldAreaNumber, areaNumber);
      }
      this.areaNumber = areaNumber;
      this._tag = `${this.areaNumber}`;

      state.allDevices().forEach((device) => {
        if (device.areaAddress == `${oldAreaNumber}`) {
          device.areaAddress = `${this.areaNumber}`;
          device.raiseOnChange("areaAddress");
        }
      });
    }
  }
  // for delete
  canBeDeletedInteractive(): boolean {
    let hasDevices = false;
    state.allDevices().forEach((device) => {
      if (device.areaAddress == `${this.areaNumber}`) {
        hasDevices = true;
      }
    });

    return !hasDevices;
  }
  getDeleteConfirmText(): string | undefined {
    let hasDevices = false;
    state.allDevices().forEach((device) => {
      if (device.areaAddress == `${this.areaNumber}`) {
        hasDevices = true;
      }
    });
    if (hasDevices) {
      return itx("AreaClass.deleteConfirmText", `Dem Bereich T1 sind Geräte zugewiesen. Wirklich löschen?`, {
        T1: this.areaNumber,
      });
    }
    return undefined;
  }

  delete(): Array<BaseObject> {
    state.settings.clearTopologyAreaNames(this.areaNumber);
    return super.delete();
  }

  updateLines() {
    const lineSet = new Set<string>();

    const areaAddress = String(this.areaNumber);

    state.allDevices().forEach((device) => {
      if (!channelTypeInfo(device.channelType).isSupply) {
        if (device.areaAddress == areaAddress) {
          const s = device.lineAddress;
          if (s != "") {
            lineSet.add(s);
          }
        }
      }
    });

    //
    // remove unused lines
    //
    this.lines.forEach((line) => {
      if (!lineSet.has(String(line.lineNumber)) && !line.createdByUser) {
        state.settings.setTopologyLineName(this.areaNumber, line.lineNumber, "");
        this.lines.removeWithoutUpdate(line);
      }
    });

    //
    // add new lines
    //

    lineSet.forEach((line) => {
      const allreadyExists = this.lines.findFirst((ln) => String(ln.lineNumber) == line);
      if (!allreadyExists) {
        this.lines.addWithoutUpdate(new Line({ _tag: line, lineNumber: parseInt(line) }, this));
      }
    });
  }

  getNextLineNumber(): number {
    const usedLineNumbers = new Set<number>();

    this.lines.forEach((line) => {
      if (line.lineNumber >= 0 && line.lineNumber <= 63) {
        usedLineNumbers.add(line.lineNumber);
      }
    });

    for (let lineNumber = 0; lineNumber <= 63; lineNumber++) {
      if (!usedLineNumbers.has(lineNumber)) {
        return lineNumber;
      }
    }

    logger.log("Area.getNextLineNumber: no free line number available in range 0..63");
    return -1;
  }

  consistencyCheck(parent: BaseModel) {
    super.consistencyCheck(parent);
    this.lines.consistencyCheck(this);
  }
}
